import { dataStarDashSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStarDashSolid = /*#__PURE__*/createIcon(dataStarDashSolid)
export default IconStarDashSolid
